import React from 'react';

import { Button, Container, Grid, makeStyles, Typography } from '@material-ui/core';

import logoSvg from '../../assets/images/logo.svg';

const useStyles = makeStyles(() => {
  return {
    buttonContainer: {
      marginTop: '1rem',
    },
    formTitle: {
      color: '#172B4D',
      fontSize: '28px',
      fontWeight: 'bold',
      marginBottom: '1rem',
    },
    loginHint: {
      color: 'rgba(0, 0, 0, 0.38)',
      fontSize: '0.8rem',
      lineHeight: 1.8,
      marginBottom: '1rem',
    },
    logo: {
      marginBottom: '3rem',
      textAlign: 'center',
    },
    mainContainer: {
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      justifyContent: 'center',
      maxWidth: '23.3rem',
    },
  };
});

export default ({ onLogin, messages }) => {
  const classes = useStyles();

  return (
    <Container component="main" className={classes.mainContainer}>
      <Container component="div" disableGutters>
        <img src={logoSvg} alt="logo" className={classes.logo} />
        <Typography variant="h4" className={`page-header ${classes.formTitle}`} align="center">
          {messages.title}
        </Typography>
        <Typography variant="body1" className={`body-copy ${classes.loginHint}`} align="center">
          {messages.message}
        </Typography>
      </Container>
      <Grid container direction="column" justify="center">
        <Grid item className={classes.buttonContainer}>
          <Button variant="contained" color="primary" fullWidth onClick={onLogin}>
            Go to Login
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};
